import { useState } from "react";
import { useInstallPrompt } from "../../hooks/useInstallPrompt";

export default function PWAInstallPrompt() {
  const { canInstall, install } = useInstallPrompt();
  const [dismissed, setDismissed] = useState(false);

  // Only offer "Install" on touch devices (phones/tablets) where a PWA install
  // is actually useful. Laptops/desktops report a fine pointer (mouse/trackpad)
  // — Chrome fires beforeinstallprompt there too, but the banner is just noise.
  const isTouchDevice =
    typeof window !== "undefined" && window.matchMedia("(pointer: coarse)").matches;

  if (!canInstall || dismissed || !isTouchDevice) return null;

  return (
    <div className="fixed bottom-4 left-1/2 z-50 -translate-x-1/2">
      <div className="flex items-center gap-3 rounded-xl border border-gray-200 bg-white px-4 py-3 shadow-lg dark:border-gray-700 dark:bg-gray-800">
        <p className="text-sm text-gray-700 dark:text-gray-200">
          Install Poultry Book for quick access.
        </p>
        <button
          onClick={install}
          className="rounded-lg bg-gray-900 dark:bg-white px-3 py-1 text-sm font-medium text-white dark:text-gray-900 hover:bg-gray-800 dark:hover:bg-gray-100"
        >
          Install
        </button>
        <button
          onClick={() => setDismissed(true)}
          className="text-sm text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}
